// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ticket-status-dot[data-v-bc286538] {\n\tdisplay: inline-block;\n\twidth: 8px;\n\theight: 8px;\n\tmargin-right: 4px;\n\tborder-radius: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
